import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

type YhcMasterVersionRecord = {
  id: string
  enabledFrom: string
  disabledAt: string
  desc: string
}

/**
 * YHC マスタバージョン
 * - 郵便番号マスタ等の取込バージョン単位で有効期間を管理する
 * - 登録・編集は yhc_masters 画面に集約。本モデルは参照・プログラム同期用
 */
export const yhc_master_versions: ModelDef<YhcMasterVersionRecord> = {
  tableName: 'yhc_master_versions',
  tableLabel: 'YHC マスタバージョン',
  primaryKeyColType: 'STRING',
  creatable: false,
  updatable: false,
  deletable: false,
  columns: {
    id: {
      type: 'STRING',
      label: 'バージョンコード',
      unique: true,
      editable: false,
      editableOnCreate: false,
      replicable: false,
      validate: { notEmpty: true },
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
    desc: {
      type: 'TEXT',
      label: '説明',
      replicable: true,
      validate: { notEmpty: true },
      width: { xs: 48 },
    },
  },
}
